/**
 * flowConfig.js
 *
 * Conventie: De 'component' property per stap moet exact overeenkomen met de naam van de Vue component
 * zoals deze geregistreerd is in Steps.vue (bijvoorbeeld 'Products', 'BaseSelection', etc.).
 *
 * De 'sidebarType' property bepaalt welk type content Sidebar.vue toont voor deze stap.
 * Mogelijke waarden: 'base', 'products', 'foodDrinks', 'packaging', 'personalization'.
 * Sidebar.vue gebruikt deze property om dynamisch de juiste sidebar content te tonen.
 */
export const flowConfig = {
  compose: {
    name: 'Samenstellen',
    steps: [
      {
        id: 'producten',
        title: 'Producten',
        subtitle: 'Eigen pakket samenstellen',
        stepTitle: '1. Kies producten',
        ctaTitle: 'Kunnen wij je helpen?',
        component: 'Products',
        endpoint: 'products',
        required: true,
        sidebarType: 'products',
      },
      {
        id: 'eten-en-drinken',
        title: 'Eten & Drinken',
        subtitle: 'Eigen pakket samenstellen',
        stepTitle: '2. Kies eten & drinken',
        ctaTitle: 'Kunnen wij je helpen?',
        component: 'FoodAndDrinks',
        endpoint: 'food',
        required: false,
        sidebarType: 'foodDrinks',
      },
      {
        id: 'verpakking',
        title: 'Verpakking',
        subtitle: 'Eigen pakket samenstellen',
        stepTitle: '3. Kies verpakking',
        ctaTitle: 'Je bent lekker op weg!',
        component: 'Packaging',
        endpoint: 'boxes',
        required: true,
        sidebarType: 'packaging',
      },
      {
        id: 'personalisatie',
        title: 'Personalisatie',
        subtitle: 'Eigen pakket samenstellen',
        stepTitle: '4. Personaliseer je pakket',
        ctaTitle: 'Vragen over personalisatie?',
        component: 'Personalization',
        endpoint: '',
        required: false,
        sidebarType: 'personalization',
      },
    ],
  },
  selectPackage: {
    name: 'Pakket Kiezen',
    steps: [
      {
        id: 'kies-basis',
        title: 'Kies basis',
        subtitle: 'Samenstellen op basispakket',
        stepTitle: '1. Start met één van onze basispakketten',
        component: 'BaseSelection',
        endpoint: 'pakket',
        required: true,
        sidebarType: 'base',
      },
      {
        id: 'producten',
        title: 'Producten',
        subtitle: 'Samenstellen op basispakket',
        stepTitle: '2. Breid uit met producten',
        component: 'Products',
        endpoint: 'products',
        required: true,
        sidebarType: 'products',
      },
      {
        id: 'eten-en-drinken',
        title: 'Eten & Drinken',
        subtitle: 'Samenstellen op basispakket',
        stepTitle: '3. Kies eten & drinken',
        component: 'FoodAndDrinks',
        endpoint: 'food',
        required: false,
        sidebarType: 'foodDrinks',
      },
      {
        id: 'verpakking',
        title: 'Verpakking',
        subtitle: 'Samenstellen op basispakket',
        stepTitle: '4. Kies verpakking',
        component: 'Packaging',
        endpoint: 'boxes',
        required: true,
        sidebarType: 'packaging',
      },
      {
        id: 'personalisatie',
        title: 'Personalisatie',
        subtitle: 'Samenstellen op basispakket',
        stepTitle: '5. Personaliseer je pakket',
        component: 'Personalization',
        endpoint: '',
        required: false,
        sidebarType: 'personalization',
      },
    ],
  },
};

export const getFlowSteps = (flowType) => {
  // Valideer flowType voordat toegang tot config
  if (!flowType || typeof flowType !== 'string') {
    return [];
  }

  const config = flowConfig[flowType];

  if (!config) {
    return [];
  }

  return config.steps || [];
};

export const getStepById = (flowType, stepId) => {
  const steps = getFlowSteps(flowType);

  // Valideer stepId voordat zoeken
  if (!stepId || typeof stepId !== 'string') {
    return null;
  }

  const step = steps.find((step) => step.id === stepId);

  if (!step) {
    // Step not found
  }

  return step;
};

export const getStepByIndex = (flowType, index) => {
  const steps = getFlowSteps(flowType);

  // Valideer index voordat toegang tot array
  if (typeof index !== 'number' || index < 0 || index >= steps.length) {
    return null;
  }

  return steps[index];
};

export const getStepIndex = (flowType, stepId) => {
  const steps = getFlowSteps(flowType);

  // Valideer stepId voordat zoeken
  if (!stepId || typeof stepId !== 'string') {
    return -1;
  }

  const index = steps.findIndex((step) => step.id === stepId);

  if (index === -1) {
    // Step not found
  }

  return index;
};
